module.exports = __webpack_public_path__ + "static/img/12.e857052.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/12.png
// module id = EJqd
// module chunks = 0